import React                        from "react";
import { Button,makeStyles,Grid}    from "@material-ui/core";

const useStyles = makeStyles(theme=>({
  welcomePageContainer: {
    background:'#FFFDFD',
    height:'calc(100vh - 79.5px)',
  },
  ContainerIzquierdo:{
    width:'97%',
    [theme.breakpoints.down(1160)]:{
      width:'100%',
    },
  },

  ContainerEstrategi:{
    position:'relative',
    width:'100vw',
    height:'calc(100vh - 79.5px - 79.5px)',
    overflow: 'auto',
  },
  ContainerSubHabilidades:{
    background:'none',
    boxSizing:'border-box',
    cursor:'pointer',
    textAlign:'center',
    display:'flex',
    padding:'43px 17px 9px 17px',
    alignItems:'center',
    position:'absolute',
    height:'40px',
    width:'62px',
    right:'3%',
    zIndex:1,
    [theme.breakpoints.down(1281)]:{
      left:'calc(50% - 31px)',
      padding:'0 0 0 62px',
    },
    [theme.breakpoints.down(600)]:{
      left:'0',
      padding:'0 15px 0 55px',
    },
        '& .Habilidades':{
      color:'#575757',
      font: 'normal 16px Lato',
      letterSpacing: '0.13px',
      display:'none',
      [theme.breakpoints.down(1281)]:{
        padding:'0 ', 
        margin:'0',
        font: ' 13px Lato',
      },
      [theme.breakpoints.down(600)]:{
        padding:'0 ', 
        margin:'0',
        font: ' 11px Lato',
      },
    },
    '&:hover':{
      border:' 5px solid #F26973',
      borderRadius: '20px 0px 20px 20px',
      background:'#fff',
      height:'215px',
      width:'233px',
      [theme.breakpoints.down(1281)]:{
        height:'75px',
        width:'350px',
        borderRadius: '0px 0px 20px 20px',
      },
      [theme.breakpoints.down(600)]:{
        height:'75px',
        width:'100%',
      },

      '& .Habilidades':{
        display:'block',
      },
      '&:before':{
        borderTop:' 0px ',
        borderRight:'0px'
      },
    },
    '&:before':{
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
      content: '"CC"',
      position: 'absolute',
      right: '0',
      top: '0',
      font: '20px Fredoka One',
      background: '#F77862',
      color: '#FFF',
      border:' 3px solid #F2624F',
      borderRadius: '0px 0px 20px 20px',
      height: '40px',
      width: '62px',
      [theme.breakpoints.down(1281)]:{
        left: '-5px',
        top: '0',
      },
      [theme.breakpoints.down(600)]:{
        height: '30px',
        width: '52px',
        font: '18px Fredoka One',
      },

    },
  },

  Estrategia:{
    margin:'0px',
    font:'38px Fredoka One',
    textAlign: 'center',
    letterSpacing: '0.28px',
    color: '#20A698',
    opacity: '1',
    [theme.breakpoints.down(1161)]:{
      font:'28px Fredoka One',
    },
    [theme.breakpoints.down(600)]:{
      font:'24px Fredoka One',
    },
  },

   TextStrg:{
      margin:'0', 
      font:'normal  22px Lato',
      letterSpacing: '0.10px',
      color: '#575757',
      opacity: 1,
      padding:'0 0 40px 0',
      boxSizing:'border-box',
      width:'760px',
      [theme.breakpoints.down(1161)]:{
        width:'650px',
        font:'normal  18px Lato',
      },
      [theme.breakpoints.down(600)]:{
        font:'normal  16px Lato',
        width:'325px',
      },
      [theme.breakpoints.down(325)]:{
        font:'normal  14px Lato',
        width:'300px',
      },
  },

   Titulo:{
    position:'absolute',
    top:'58px',
    [theme.breakpoints.down(1161)]:{
      top:'80px',
    },
  },
  Objet1:{
    position:'absolute',
    top:'130px',
    '& .Td':{
      height:'42px',
      border:'solid 1.5px #000',
      width:'360px',
      margin:'0', 
      font:' 22px Lato',
      letterSpacing: '0.10px',
      color: '#575757',
      boxSizing:'border-box',
      padding:'0 0 5px 10px',
      [theme.breakpoints.down(1161)]:{
        font:'normal  18px Lato',
        width:'300px',

      },
      [theme.breakpoints.down(600)]:{
        width:'162px',
        font:'normal  16px Lato',
      },
    },
    '& .Td2':{
      width:'240px',
    },
    '& .Td3':{
      width:'440px',
    },
    '& .Br':{
      margin:'0 0 20px 0'
    },
    '& .ul':{
      margin:'22px 0',
      padding:'0 0 0 22px',
    },
    '& .li':{
      marginBottom:'10px',
    },
   '& .Amarillo':{
    textAlign:'center',
    height:'42px',
    background:'#F7DF92',
    padding:'0 ',
   },
   '& .Verde':{
    textAlign:'center',
    height:'42px',
    background:'#84E9DF',
    padding:'0 ',
   },
  },


  ContainerBarraInferior:{
    position:'relative',
    background:'#F3CD52',
    height:'79.51px',
    [theme.breakpoints.up(1920)]:{
      height:'8vh',
    },
    [theme.breakpoints.down(1161)]:{
      background: 'linear-gradient(280deg, #D3348F 0%, #F1CB5A 100%) 0% 0% ',
    },
  },

  ContainerBarraDerecha:{
    background: 'linear-gradient(180deg, #D3348F 0%, #F1CB5A 100%) 0% 0%',
    width:'3%',
    height:'100vh',
    [theme.breakpoints.down(1161)]:{
      display:'none',
    },
  },
  
   BotonAvanza:{
    position:'absolute',
    bottom:'52px',
    right:'134px',
    textTransform:'none',
    textDecoration:'none',
    height:'62px',
    width:'279px',  
    background: '#7A54BA',
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: '61px',
    color: '#FFFFFF',
    font: 'bold 20px lato ',
    '&:hover':{
        background: '#dd78fb',
      },
    [theme.breakpoints.down(1161)]:{
      position:'relative',
      bottom:'32px',
      left:'0',
      right:'0',
    },
  },

    
}));

const ReadingStrategys = (props) => {
  const classes = useStyles();
  const {activeStep, setActiveStep, handleNextStep} = props

  const handleContinue = () => {
    setActiveStep(activeStep + 1)
    handleNextStep()
  }

  return(

    <Grid  container direction="column" item sm={12} className={classes.welcomePageContainer} >
<div className={classes.ContainerSubHabilidades}>
          <p className="Habilidades">Producir textos argumentativos críticos a partir de lo leído.</p>
      </div>
      <Grid container item sm={12} justifyContent="center" className={classes.ContainerIzquierdo} >

        <Grid container item className={classes.ContainerEstrategi } >

              <Grid container item justifyContent="center" alignItems="center" sm={12} className={classes.Titulo}> 
                <p className={classes.Estrategia} >Estrategia de lectura</p>
              </Grid>

              <Grid container item sm={12} alignItems="center" justifyContent="center" className={classes.Objet1}>
                  <p className={classes.TextStrg}>
                    Antes de comenzar, repasa un poco.<div className="Br"></div>

                    Un argumento es el texto que defiende una idea o una opinión. Sirve para probar 
                    un punto de vista sobre un texto, debate o investigación. También se aplica en una 
                    conversación como parte de un intercambio de ideas o para explicar fenómenos o 
                    eventos por medio de las hipótesis. <div className="Br"></div>

                    Sin darte cuenta, la argumentación es parte de la vida diaria, por ejemplo, cuando 
                    defiendes la manera en que ves el mundo y las decisiones que tomas.<div className="Br"></div>

                    La argumentación tiene tres componentes básicos:<div className="Br"></div>    

                  <tr>
                    <tr>
                      <td valign="middle" className="Td Verde"><b>Componentes</b></td>
                      <td valign="middle" className="Td Verde"><b>Ejemplo de argumento sobre el <br/>uso del cubrebocas para combatir<br/>la infección de Covid</b></td>
                    </tr>
                    <tr>
                      <td valign="middle" className="Td"><b>Tema. </b>Idea que se expone y <br/>defiende </td>
                      <td valign="middle" className="Td">El usar cubrebocas protege de <br/>Covid-19.</td>
                    </tr>
                    <tr>
                      <td valign="middle" className="Td"><b>Argumentos. </b>Datos utilizados para <br/>defender el tema</td>
                      <td valign="middle" className="Td">
                        La transmisión de Covid-19 sucede <br/>
                        cuando una persona infectada <br/>
                        respira, habla, estornuda o tose <br/>
                        expulsando gotitas infectadas en el <br/>
                        aire. Si otra persona se encuentra <br/>
                        cerca, estas gotitas pueden llegar a <br/>
                        su nariz, boca u ojos. 
                      </td>
                    </tr>
                    <tr>
                      <td valign="middle" className="Td"><b>Conclusión.</b>Resumen de lo expuesto</td>
                      <td valign="middle" className="Td">
                        Por esta razón, todos deben usar <br/>
                        cubrebocas para reducir el contagio <br/>
                        de Covid-19. 
                      </td>
                    </tr>
                  </tr>
              
                    <br/>

                    En la vida cotidiana, los argumentos pueden ser breves. Lee el ejemplo:

                    <ul className="ul">
                      <li className="li">
                        Los pasteles que hace mi mamá son deliciosos, porque le pone frutas naturales.
                      </li>
                    </ul>

                    Ahora es tu turno. Para ello, sigue las instrucciones.

                    <ul className="ul">
                      <li className="li">
                        Escoge un texto que llame tu atención, en el que se exponga un tema. Léelo con 
                        mucho detenimiento, ¡no se vale estar distraído!
                      </li>
                      <li className="li">
                        Toma la hoja y haz un cuadro como el siguiente:
                      </li>
                    </ul>
                  <tr>
                    <tr>
                      <td valign="middle" className="Td Td2 Verde"><b></b></td>
                      <td valign="middle" className="Td Td3 Verde"><b>Tema elegido / postura en favor o en contra:</b></td>
                    </tr>
                    <tr>
                      <td valign="middle" className="Td Td2"><b>Tema</b></td>
                      <td valign="middle" className="Td Td3"></td>
                    </tr>
                    <tr>
                      <td valign="middle" className="Td Td2"><b>Argumentos</b></td>
                      <td valign="middle" className="Td Td3">
                      </td>
                    </tr>
                    <tr>
                      <td valign="middle" className="Td Td2"><b>Conclusión</b></td>
                      <td valign="middle" className="Td Td3">
                      </td>
                    </tr>
                  </tr>
                    <ul className="ul">
                      <li className="li">
                        Al terminar la lectura, tendrás que llenar los recuadros con cada uno de los 
                        componentes, según estés a favor o en contra de lo que se expresa del 
                        tema tratado.
                      </li>
                    </ul>

                    ¡Excelente! Cuando hayas terminado, habrás argumentado. ¡No olvides practicar 
                    mucho! Ahora sí, ¿listo para seguir?
                </p>

              </Grid>
                
        </Grid>
        
        <Grid container item sm={12} className={classes.ContainerBarraInferior} justifyContent="center">
            <Button id="BotonContinuarEstrategias" className={classes.BotonAvanza} onClick={handleContinue}>
              Continuar
            </Button>
        </Grid>
        
      </Grid>

      <Grid container item sm={12} className={classes.ContainerBarraDerecha}></Grid>

    </Grid>

  )
}

export default ReadingStrategys;
